<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable @change="getGroupList(params.params.baseId)"
            placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="params.params.periodId" filterable placeholder="请选择造次">
            <el-option label="全部造次" value=""></el-option>
            <el-option v-for="item in periodList" :key="item.periodId" :label="item.periodName" :value="item.periodId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" filterable placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.breedTypeId" :label="item.breedTypeName"
              :value="item.breedTypeId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.breedId" :label="item.breedName" :value="item.breedId">
            </el-option>
          </el-select>
        </div>
        <!-- 选择日期年月日 -->
        <div class="page-search-date">
          <!-- -----------------------------去掉月日先暂时不删相关代码------------------------------------ -->
          <div class="page-search-item date-selection-box">
            <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
            <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
            <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'Y'">
            <label>年份&nbsp;:</label>
            <el-date-picker format="yyyy" value-format="yyyy" v-model="params.params.year" type="year"
              placeholder="请选择年份">
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'M'">
            <label>月份&nbsp;:</label>
            <el-date-picker v-model="params.params.startDate" format="yyyy-MM" value-format="yyyy-MM"
              @change="monthChange" type="month" placeholder="选择月份">
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'D'">
            <label>日期&nbsp;:</label>
            <el-date-picker v-model="params.params.startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              @change="dateChange" type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">
          <i class="title-icon"></i>养殖投苗年报表
        </div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">
          <i class="title-icon"></i>养殖投苗月报表
        </div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          <i class="title-icon"></i>养殖投苗日报表
        </div>
        <div>单位 : {{ orgName }}</div>
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">年份 : {{ showYear }}年</div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">
          月份 :
          {{ showStartDate }}
        </div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          日期 :
          {{ showStartDate }}
        </div>
        <div>
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="toDetails" style="margin-right: 20px">明细</span>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格-年 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-if="params.params.type == 'Y'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="boxFy" label="日期"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本年投苗情况">
          <el-table-column prop="seedlingNum" label="投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="seedlingBoxNum" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="seedlingArea" label="面积(亩)，体积(立方)">
          </el-table-column>
          <el-table-column prop="seedlingDensity" label="平均密度(万尾/亩，万尾/立方)">
          </el-table-column>
        </el-table-column>
        <el-table-column :label="'(' + showYear + ')年度目标任务完成情况'">
          <el-table-column prop="seedlingNumTarget" label="计划投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="completionVarianceTarget" label="完成差异量（万尾）">
          </el-table-column>
          <el-table-column prop="completionRateTarget" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年比完成情况">
          <el-table-column prop="seedlingNumLd" label="去年同期投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="completionVarianceSameYear" label="完成差异量（万尾）">
          </el-table-column>
          <el-table-column prop="completionRateSameYear" label="增幅%">
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 表格-月 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-if="params.params.type == 'M'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="seedlingMonth" label="日期"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本月投苗情况">
          <el-table-column prop="seedlingNum" label="投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="seedlingBoxNum" label="塘数\箱数(口)">
          </el-table-column>
          <el-table-column prop="seedlingArea" label="面积(亩)，体积(立方)">
          </el-table-column>
          <el-table-column prop="seedlingDensity" label="平均密度(万尾/亩，万尾/立方)">
          </el-table-column>
        </el-table-column>
        <el-table-column label="本月累计情况">
          <el-table-column prop="seedlingNumCy" label="投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="seedlingBoxNumCy" label="塘数\箱数（口）">
          </el-table-column>
          <el-table-column prop="seedlingAreaCy" label="面积(亩)，体积(立方)">
          </el-table-column>
          <el-table-column prop="seedlingDensityCy" label="平均密度(万尾/亩，万尾/立方)">
          </el-table-column>
        </el-table-column>
        <el-table-column :label="'(' + showStartDate.substring(0, 4) + ')年度目标任务完成情况'">
          <el-table-column prop="seedlingNumTarget" label="计划投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="completionVarianceTarget" label="完成差异量（万尾）">
          </el-table-column>
          <el-table-column prop="completionRateTarget" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年同月比月完成情况">
          <el-table-column prop="seedlingNumLd" label="去年同月投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="completionVarianceSameMonth" label="完成差异量（万尾）">
          </el-table-column>
          <el-table-column prop="completionRateSameMonth" label="增幅%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="与去年同月比月累计完成情况">
          <el-table-column prop="seedlingNumLy" label="去年同月投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="completionVarianceSameMonthCy" label="完成差异量（万尾）">
          </el-table-column>
          <el-table-column prop="completionRateSameMonthCy" label="增幅%">
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 表格-日 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" v-if="params.params.type == 'D'"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="date" label="日期"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本日投苗情况">
          <el-table-column prop="seedlingNum" label="投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="seedlingBoxNum" label="塘数\箱数（口）">
          </el-table-column>
          <el-table-column prop="seedlingArea" label="面积(亩)，体积(立方)">
          </el-table-column>
          <el-table-column prop="seedlingDensity" label="平均密度(万尾/亩，万尾/立方)">
          </el-table-column>
          <el-table-column prop="suppliersName" label="供应商">
          </el-table-column>
        </el-table-column>
        <el-table-column label="本日累计情况">
          <el-table-column prop="seedlingNumCy" label="投苗量（万尾）">
          </el-table-column>
          <el-table-column prop="seedlingBoxNumCy" label="塘数\箱数（口）">
          </el-table-column>
          <el-table-column prop="seedlingAreaCy" label="面积(亩)，体积(立方)">
          </el-table-column>
          <el-table-column prop="seedlingDensityCy" label="平均密度(万尾/亩，万尾/立方)">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  searchOutSeedlingDailyGroupList,
  exportOutSeedlingDailyGroupList,
  getTypeConditions,
  getPeriodConditions,
  getBreedConditions,
} from "../ym-put/ym-put-service";
import {
  queryBaseDataListByRole,
  queryBaseGroupList,
} from "@/api/middle/common";
import Page from "@/utils/methods/page";
export default {
  name: "egg",
  data() {
    return {
      PageDisplay: true,
      orgName: "", // 单位名称
      showYear: "", // 显示的年份
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "boxFy",
          fixed: false,
          selected: false
        },
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          orgId: "",
          baseId: "",
          breedTypeId: "",
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString(),
          startDate: "",
          endDate: "",
          type: "Y",
          breedTypeClass: "fish",
          groupId: "",
          periodId: "",
          breedId: "",
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      baseList: [],//养殖场列表
      groupList: [], // 区域列表
      breedTypeList: [], // 品类列表
      periodList: [],
      breedList: [],
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.orgName = localStorage.getItem("orgName");
    // 养殖场
    queryBaseDataListByRole().then((res) => {
      if (res.code == "0000") {
        this.baseList = res.data;
      }
    });
    // 品类
    getTypeConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.breedTypeList = res.data;
      }
    });
    getPeriodConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.periodList = res.data;
      }
    });
    getBreedConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.breedList = res.data;
      }
    });
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 根据养殖场获取区域
    getGroupList(baseId) {
      this.params.params.groupId = "";
      this.groupList = [];
      if (!baseId) return
      this.params.params.groupId = "";
      queryBaseGroupList({
        baseId,
      }).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val;
      this.params.params.endDate = val;
    },
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val;
      this.params.params.endDate = val;
    },
    // 查询
    search() {
      this.getPageList();
    },
    // 初始化时间
    initTime() {
      this.params.params.year = null;
      this.params.params.startDate = null;
      this.params.params.endDate = null;
      if (this.params.params.type == "Y") {
        this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString();
        this.fixedColumnList[0].prop = "boxFy";
      }
      if (this.params.params.type == "M") {
        this.params.params.startDate = this.$moment().format("YYYY-MM");
        this.params.params.endDate = this.$moment().format("YYYY-MM");
        this.fixedColumnList[0].prop = "seedlingMonth";
      }
      if (this.params.params.type == "D") {
        this.params.params.startDate = this.$moment(
          `${new Date().getFullYear()}-03-01`
        ).format("YYYY-MM-DD");
        this.params.params.endDate = this.$moment(
          `${new Date().getFullYear()}-03-01`
        ).format("YYYY-MM-DD");
        this.fixedColumnList[0].prop = "date";
      }
    },
    // 重置
    reset() {
      this.params.params.breedTypeId = "";
      this.params.params.baseId = "";
      this.params.params.groupId = "";
      this.params.params.periodId = "";
      this.params.params.breedId = "";
      this.initTime();
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    toDetails() {
      let routeUrl = this.$router.resolve({
        path: "/month/ym/put/details",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.breedName === "合计") {
        return "heji-row";
      }
    },
    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.year) {
        this.showYear = this.params.params.year;
      }
      if (this.params.params.type == "M") {
        this.showStartDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月"
        );
      }
      if (this.params.params.type == "D") {
        this.showStartDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月DD日"
        );
      }
    },
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      searchOutSeedlingDailyGroupList(this.params).then((res) => {
        if (res.code == "0000") {
          this.tableData = res.data.list;
          this.showListData();
          this.exportParams = JSON.parse(JSON.stringify(this.params.params));
        }
        loading.close();
      });
    },
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        this.exportParams.fileName = "养成投放概览投苗情况";
        Page.exportDatas(exportOutSeedlingDailyGroupList(), this.exportParams);
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    // 监听type年月日变化
    "params.params.type"(val) {
      this.initTime();
      this.getPageList();
    },
  },
};
</script>

<style></style>